import React from "react";
import Book from "./edit/Book";
import BookUpload from "./upload/BookUpload";
import Magazine from "./edit/Magazine";
import Booklet from "./edit/Booklet";
import Minibook from "./edit/Minibook";
import Audio from "./edit/Audio";
import Video from "./edit/Video";
import News from "./edit/News";
import { IoIosAdd } from "react-icons/io";
import MagazineUpload from "./upload/MagazineUpload";
import BookletUpload from "./upload/BookletUpload";
import MinibookUpload from "./upload/MinibookUpload";
import AudioUpload from "./upload/AudioUpload";
import VideoUpload from "./upload/VideoUpload";
import NewsUpload from "./upload/NewsUpload";

export default function ManageContent() {
  return (
    <>
      <nav className="navbar bg-body-tertiary">
        <div className="container-fluid">
          <span className="navbar-brand mb-0 h1">Manage Contents</span>
        </div>
      </nav>
      <div dir="ltr" className="p-3">
        <nav>
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            <button
              className="nav-link border-0 active"
              id="nav-book-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-book"
              type="button"
              role="tab"
              aria-controls="nav-book"
              aria-selected="true"
            >
              Book
            </button>
            <button
              className="nav-link border-0"
              id="nav-magazine-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-magazine"
              type="button"
              role="tab"
              aria-controls="nav-magazine"
              aria-selected="false"
            >
              Magazine
            </button>
            <button
              className="nav-link border-0"
              id="nav-booklet-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-booklet"
              type="button"
              role="tab"
              aria-controls="nav-booklet"
              aria-selected="false"
            >
              Booklet
            </button>
            <button
              className="nav-link border-0"
              id="nav-minibook-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-minibook"
              type="button"
              role="tab"
              aria-controls="nav-minibook"
              aria-selected="false"
            >
              Minibook
            </button>
            <button
              className="nav-link border-0"
              id="nav-audio-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-audio"
              type="button"
              role="tab"
              aria-controls="nav-audio"
              aria-selected="false"
            >
              Audio
            </button>
            <button
              className="nav-link border-0"
              id="nav-video-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-video"
              type="button"
              role="tab"
              aria-controls="nav-video"
              aria-selected="false"
            >
              Video
            </button>
            <button
              className="nav-link border-0"
              id="nav-news-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-news"
              type="button"
              role="tab"
              aria-controls="nav-news"
              aria-selected="false"
            >
              News
            </button>
          </div>
        </nav>
        <div className="tab-content" id="nav-tabContent">
          <div
            className="tab-pane px-3 py-4 bg-body rounded-2 fade show active "
            id="nav-book"
            role="tabpanel"
            aria-labelledby="nav-book-tab"
            tabIndex="0"
          >
            <p className="d-inline-flex gap-1">
              <button
                className="btn btn-success"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                ریکارد جدید <IoIosAdd />
              </button>
            </p>
            <div className="collapse" id="collapseExample">
              <div className="card card-body">
                <BookUpload />
              </div>
            </div>
            <Book />
          </div>
          <div
            className="tab-pane px-3 py-4 bg-body rounded-2 fade"
            id="nav-magazine"
            role="tabpanel"
            aria-labelledby="nav-magazine-tab"
            tabIndex="0"
          >
            <p className="d-inline-flex gap-1">
              <button
                className="btn btn-success"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                ریکارد جدید <IoIosAdd />
              </button>
            </p>
            <div className="collapse" id="collapseExample">
              <div className="card card-body">
                <MagazineUpload />
              </div>
            </div>
            <Magazine />
          </div>
          <div
            className="tab-pane px-3 py-4 bg-body rounded-2 fade"
            id="nav-booklet"
            role="tabpanel"
            aria-labelledby="nav-booklet-tab"
            tabIndex="0"
          >
            <p className="d-inline-flex gap-1">
              <button
                className="btn btn-success"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                ریکارد جدید <IoIosAdd />
              </button>
            </p>
            <div className="collapse" id="collapseExample">
              <div className="card card-body">
                <BookletUpload />
              </div>
            </div>
            <Booklet />
          </div>
          <div
            className="tab-pane px-3 py-4 bg-body rounded-2 fade"
            id="nav-minibook"
            role="tabpanel"
            aria-labelledby="nav-minibook-tab"
            tabIndex="0"
          >
            <p className="d-inline-flex gap-1">
              <button
                className="btn btn-success"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                ریکارد جدید <IoIosAdd />
              </button>
            </p>
            <div className="collapse" id="collapseExample">
              <div className="card card-body">
                <MinibookUpload />
              </div>
            </div>
            <Minibook />
          </div>
          <div
            className="tab-pane px-3 py-4 bg-body rounded-2 fade"
            id="nav-audio"
            role="tabpanel"
            aria-labelledby="nav-audio-tab"
            tabIndex="0"
          >
            <p className="d-inline-flex gap-1">
              <button
                className="btn btn-success"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                ریکارد جدید <IoIosAdd />
              </button>
            </p>
            <div className="collapse" id="collapseExample">
              <div className="card card-body">
                <AudioUpload />
              </div>
            </div>
            <Audio />
          </div>
          <div
            className="tab-pane px-3 py-4 bg-body rounded-2 fade"
            id="nav-video"
            role="tabpanel"
            aria-labelledby="nav-video-tab"
            tabIndex="0"
          >
            <p className="d-inline-flex gap-1">
              <button
                className="btn btn-success"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                ریکارد جدید <IoIosAdd />
              </button>
            </p>
            <div className="collapse" id="collapseExample">
              <div className="card card-body">
                <VideoUpload />
              </div>
            </div>
            <Video />
          </div>
          <div
            className="tab-pane px-3 py-4 bg-body rounded-2 fade"
            id="nav-news"
            role="tabpanel"
            aria-labelledby="nav-news-tab"
            tabIndex="0"
          >
            <p className="d-inline-flex gap-1">
              <button
                className="btn btn-success"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                ریکارد جدید <IoIosAdd />
              </button>
            </p>
            <div className="collapse" id="collapseExample">
              <div className="card card-body">
                <NewsUpload />
              </div>
            </div>
            <News />
          </div>
        </div>
      </div>
    </>
  );
}
